// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nwh2","content":"styles_content__2wOkP"};